<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button, Card, Form, FormItem } from "view-design";
import mod from "./modal.vue";
export default {
  extends: baseList,
  components: {
    mod,
  },
  data() {
    return {
      table: {
        mname: "commodity",
        key: "id",
        url: {},
        output: false,
      },
      menus: [
        {
          label: "兑换列表",
          name: "commodity_list",
          auth: "/admin/commodity/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
      ],
      actions: [
        // {
        //   label: "新增",
        //   icon: "md-add",
        //   onClick: this.toAdd,
        //   auth: "/admin/commodity/add",
        // },
      ],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/commodity/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/commodity/lists' },
      ],
      query: {},
      currentRow: null,
      filters: [
        { label: '用户', name: 'user_name', value: '', type: 'input' },
        { label: "兑换物品", name: "content", value: "", type: "input" },
      ],
      tableCols: [
        {
          title: "ID",
          width: 80,
          key: "id",
        },
        {
          title: "用户",
          key: "publish_name",
          width: 200,
          // align: "center",
          render: (h, { row }) => {
            let uname = row.user_name;
            let src = row.publish_head;
            let uid = row.user?.uid;
            return h(
              "div",
              {
                style: {
                  height: "34px",
                  lineHeight: "34px",
                  overflow: "hidden",
                },
              },
              [
                // h("Avatar", {
                //   props: {
                //     src: src,
                //   },
                //   attrs: {
                //     title: "UID: " + uid,
                //   },
                //   style: {},
                // }),
                h(
                  "span",
                  {
                    attrs: {
                      title: uname,
                    },
                    style: {
                      marginLeft: "5px",
                      width: "auto",
                      height: "34px",
                      overflow: "hidden",
                    },
                  },
                  uname
                ),
              ]
            );
          },
        },
        {
          title: "手机号",
          key: "user_phone",
          minWidth: 150,
        },
        {
          title: "消耗水票",
          key: "integral_count",
          minWidth: 100,
        },
        {
          title: "兑换物品",
          key: "content",
          minWidth: 100,
        },
        {
          title: "图集",
          key: "gallery",
          viewimages: true,
          minWidth: 100,
        },
        {
          title: "申请时间",
          key: "create_time",
          minWidth: 100,
        },
        {
          title: "申请状态",
          key: "is_use",
          minWidth: 100,
          render(h, { row }) {
            return (
              <span>
                {row.is_use == 0 ? (
                  <span style={{ color: "#3E8BED" }}>待审核</span>
                ) : row.is_use == 1 ? (
                  <span style={{ color: "#A1B7D0" }}>审核完成</span>
                ) : row.is_use == 2 ? (
                  <span style={{ color: "#F36B6B" }}>申请拒绝</span>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 100,
        },
        {
          title: "操作",
          key: "id",
          minWidth: 200,
          handle: [
            // (vm, h, currentRow, param) => {
            //   const row = param.row;
            //   let directives = [{ name: "auth", value: "/admin/reverb/edit" }];
            //   return (
            //     <Button
            //       {...{ directives }}
            //       size="small"
            //       onClick={() => this.Detail(currentRow)}
            //       type="info"
            //       style={{ margin: "4px 5px" }}
            //     >
            //       详情
            //     </Button>
            //   );
            // },
            (vm, h, currentRow, param) => {
              const row = param.row;
              let directives = [
                { name: "auth", value: "/admin/commodity/edit" },
              ];
              // console.log(currentRow);
              if (currentRow.is_use == 1 || currentRow.is_use == 2) {
                return "";
              }
              return (
                <Button
                  size="small"
                  {...directives}
                  onClick={() => this.Ok({ id: currentRow.id, type: 1 })}
                  style={{ margin: "4px 5px" }}
                  // disabled={currentRow.is_use == 1 || currentRow.is_use == 2}
                  type="success"
                >
                  通过
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              const row = param.row;
              let directives = [
                { name: "auth", value: "/admin/commodity/edit" },
              ];
              if (currentRow.is_use == 1 || currentRow.is_use == 2) {
                return "";
              }
              return (
                <Button
                  {...directives}
                  size="small"
                  onClick={() => this.Ok({ id: currentRow.id, type: 2 })}
                  style={{ margin: "4px 5px" }}
                  // disabled={currentRow.is_use == 1 || currentRow.is_use == 2}
                  type="error"
                >
                  拒绝
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {},

  methods: {
    Detail(row) {
      this.$Modal.info({
        // title: row.title,
        // width: 1000,
        render: () => (
          <div class="DtlBox">
            <Form label-width="80">
              <FormItem>
                <strong slot="label">申请人:</strong>
                {row.user_name}
              </FormItem>
              <FormItem>
                <strong slot="label">申请物品:</strong>
                {row.content}
              </FormItem>
              <FormItem>
                <strong slot="label">消耗水票:</strong>
                {row.integral_count}
              </FormItem>
              <FormItem>
                <Card title="备注">{row.remark}</Card>
              </FormItem>
            </Form>
          </div>
        ),
      });
    },
    Ok(q) {
      let setpost = async () => {
        console.log(this.$refs.mod.formValidate);
        let obj = {
          ...q,
          ...this.$refs.mod.formValidate,
        };
        let res = await $utils.api.load("admin/api/commodity/verify", obj);
        if (res.code == 1) {
          this.$Message.success(res.message);
          this.$refs.tablelist.ajaxData();
          return true;
        }
      };

      let strdome = `<strong style="fontSize:20px">${
        q.type == 1 ? "通过" : "拒绝"
      }</strong>`;
      this.$Modal.confirm({
        title: strdome,
        render: () => {
          return <mod ref="mod" type={q.type} />;
        },
        ok: setpost,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.DtlBox {
  .ivu-form-item {
    margin-bottom: 0;
  }
}
</style>
